import { SOURCE_TYPE_LABEL } from "../../shared/sources";

/** "Stok hareketleri (ERP_STOK)": etiket normal, kod gri (glossary §3, #164). */
export function SourceTypeName({ code }: { code: string }) {
  const label = SOURCE_TYPE_LABEL[code as keyof typeof SOURCE_TYPE_LABEL];
  return label ? <span className="whitespace-nowrap">{label} <span className="text-muted-foreground">({code})</span></span> : <>{code}</>;
}
